import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, ModalHeader } from "./AdminShared";

function UserConsultationModal({
    show,
    user,
    onClose,
}) {
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (!show || !user?.user_id) return;

        fetchConsultations();
    }, [show, user]);

    const fetchConsultations = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("adminToken");

            const res = await axios.get(
                `https://test.conversationaily.ai/api/user_pre-scenario/data?user_id=${user.user_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setSessions(res?.data?.data || res?.data || []);
        } catch (error) {
            console.error("Failed to fetch consultations:", error);
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <Modal onClose={onClose} wide>
            <ModalHeader
                title={user?.student_name || "Consultations"}
                sub={user?.student_email}
                onClose={onClose}
            />

            <div className="p-6 overflow-auto max-h-[75vh]">
                {loading ? (
                    <div className="text-center py-10 text-gray-500">
                        Loading consultations...
                    </div>
                ) : (
                    <table className="w-full text-sm">
                        <thead className="bg-gray-50 sticky top-0">
                            <tr>
                                <th className="p-3 text-left">Case</th>
                                <th className="p-3 text-left">Speciality</th>
                                <th className="p-3 text-left">Empathy</th>
                                <th className="p-3 text-left">Tone</th>
                                <th className="p-3 text-left">Duration</th>
                                <th className="p-3 text-left">Date</th>
                            </tr>
                        </thead>

                        <tbody>
                            {sessions.length > 0 ? (
                                sessions.map((session) => (
                                    <tr
                                        key={session.session_id}
                                        className="border-b hover:bg-orange-50"
                                    >
                                        <td className="p-3">{session.case_type || "-"}</td>
                                        <td className="p-3">{session.speciality || "-"}</td>
                                        <td className="p-3">{session.empathy_score ?? "-"}</td>
                                        <td className="p-3">{session.tone || "-"}</td>
                                        <td className="p-3">
                                            {session.duration_seconds
                                                ? `${session.duration_seconds}s`
                                                : "-"}
                                        </td>
                                        <td className="p-3">
                                            {session.session_date
                                                ? new Date(session.session_date).toLocaleString()
                                                : "-"}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan={6}
                                        className="text-center py-8 text-gray-400"
                                    >
                                        No consultations found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </Modal>
    );
}

export default UserConsultationModal;